module.exports = __webpack_public_path__ + "static/media/Piercing-jewelry.e954bacd.png";